import React from 'react';
import { MapPinIcon, ClockIcon, TruckIcon, HeartIcon } from 'lucide-react';
export function TopUtilityBar() {
  return <div className="gradient-blue text-white py-2 px-4 text-xs sm:text-sm font-medium" data-id="element-574">
      <div className="container-wide flex justify-between items-center" data-id="element-575">
        {/* Mobile: Key message */}
        <div className="flex md:hidden w-full justify-between items-center" data-id="element-576">
          <div className="flex items-center gap-2" data-id="element-577">
            <TruckIcon className="w-4 h-4 text-brand-green-300" data-id="element-578" />
            <span className="font-bold" data-id="element-579">FREE Drop-off Within 5km</span>
          </div>
          <a href="https://www.facebook.com/BetterPetsandGardens" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors" data-id="element-580">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-581">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-582" />
            </svg>
          </a>
        </div>

        {/* Desktop: Full list */}
        <div className="hidden md:flex w-full justify-between items-center" data-id="element-583">
          <div className="flex items-center gap-6" data-id="element-584">
            <div className="flex items-center gap-2" data-id="element-585">
              <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="Western Australian Owned" className="h-7 w-7 rounded-full object-cover" data-id="element-586" />
              <span className="font-bold" data-id="element-587">Proudly WA Owned</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-588">
              <MapPinIcon className="w-4 h-4 text-brand-blue-200" data-id="element-589" />
              <span data-id="element-590">6 Store Locations</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-591">
              <ClockIcon className="w-4 h-4 text-brand-blue-200" data-id="element-592" />
              <span data-id="element-593">Open 7 Days</span>
            </div>
          </div>

          <div className="flex items-center gap-6" data-id="element-594">
            <div className="flex items-center gap-2 bg-brand-green/20 px-3 py-1 rounded-full border border-brand-green-300/30" data-id="element-595">
              <TruckIcon className="w-4 h-4 text-brand-green-300" data-id="element-596" />
              <span className="font-bold text-brand-green-300" data-id="element-597">
                FREE Drop-off Within 5km*
              </span>
            </div>
            <div className="flex items-center gap-2 text-brand-blue-100 hover:text-white cursor-pointer transition-colors" data-id="element-598">
              <HeartIcon className="w-4 h-4" data-id="element-599" />
              <span className="underline underline-offset-2" data-id="element-600">
                Customer Care Club
              </span>
            </div>
            <a href="https://www.facebook.com/BetterPetsandGardens" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" aria-label="Follow us on Facebook" data-id="element-601">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-602">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-603" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>;
}